export default __webpack_public_path__ + "static/media/chineseRoof.8bdba886.png";